import { List, Tag } from "antd";
import CustomBreadCrumb from "components/CustomBreadCrumb/CustomBreadCrumb";
import PageLayout from "layout/PageLayout/PageLayout";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import centralApi from "services/centralApi";
import "./CrashDetailedView.css";
import { API_ENDPOINTS, ROUTES } from "utils/constants";
import { ApmApiMethods } from "utils/enums";
import { t } from "i18next";
interface CrashDetailedViewProps {}

const CrashDetailedView: FC<CrashDetailedViewProps> = () => {
  const location = useLocation();
  const loginUser = useSelector((state: any) => state.loginUser.data);
  const { appId } = useSelector((state: any) => state.activeApp);
  const id = location.search?.split("=")?.[1];
  const [issue, setIssue] = useState<{
    data: {
      frames: any[];
      title: string;
      eventID: string;
      metadata: { function: string; value: string; type?: string };
    };
    loading: boolean;
  }>({
    data: {
      frames: [],
      title: "",
      eventID: "",
      metadata: { function: "", value: "" },
    },
    loading: true,
  });
  const getIssue = async () => {
    try {
      setIssue((prevState) => ({ ...prevState, loading: true }));
      const params = {
        api_key: loginUser.api_key,
        app_id: appId,
        id,
        api_method: ApmApiMethods.EVENTS,
      };
      const data = await centralApi(
        "POST",
        API_ENDPOINTS.APM_METRICS_URL,
        params
      );

      const stack_trace_frames =
        data?.entries?.[0]?.data?.values?.[0]?.stacktrace?.frames;
      setIssue((prevState) => ({
        ...prevState,
        data: {
          frames: stack_trace_frames || [],
          title: data.title,
          eventID: data.eventID,
          metadata: data.metadata,
        },
        loading: false,
      }));
    } catch (error) {
      setIssue((prevState) => ({
        ...prevState,
        data: {
          frames: [],
          eventID: "",
          title: "",
          metadata: { function: "", value: "" },
        },
        loading: false,
      }));
    }
  };
  useEffect(() => {
    if (location.search) {
      getIssue();
    }
  }, [location]);

  return (
    <PageLayout
      className="crash-detailed-view-container"
      title={`${t("analyzeLabel")}`}
      topLeftItem={
        <CustomBreadCrumb
          items={[
            {
              title: (
                <Link to={ROUTES.DASHBOARD_ANALYZE_CRASHES}>
                  {t("issuesLabel")}
                </Link>
              ),
            },
            {
              title: <span>{t("viewLabel")}</span>,
            },
          ]}
        />
      }
    >
      <div className="mb-4 d-flex justify-content-between">
        <div>
          <strong>{t("stackTraceLabel")}</strong>

          <Tag color="red" className="d-flex flex-column gap-1 mt-3 ">
            <strong>
              {issue.data?.metadata?.type || issue.data?.metadata?.function}
            </strong>
            <span
              style={{ maxWidth: "70vh" }}
              className="text-overflow-ellipsis"
            >
              {issue.data?.metadata?.value}
            </span>
          </Tag>
        </div>
        <div className="d-flex gap-2 align-items-start">
          <strong>{t("eventIdLabel")}</strong>
          <span>{issue.data.eventID}</span>
        </div>
      </div>
      <List
        loading={issue.loading}
        itemLayout="vertical"
        className="crash-stacktrace-list"
        dataSource={issue.data?.frames?.reverse()}
        renderItem={(item) => (
          <div className="crash-stacktrace-frame  rounded d-flex justify-content-between w-100 p-2">
            <div className="d-flex gap-2">
              <span>{item.filename || item.module}</span>
              {item.function ? (
                <div className="d-flex gap-2">
                  <span className="text-muted">{t("inLabel")}</span>
                  <span>{item.function}</span>
                </div>
              ) : (
                <span>{t("anonymousLabel")}</span>
              )}
              {item.lineNo ? (
                <span className="text-muted">{t("onLineLabel")}</span>
              ) : (
                <></>
              )}
              {item.lineNo}
              {item.colNo ? `:${item.colNo}` : ""}{" "}
            </div>
            <div>
              {item.inApp ? (
                <Tag color={"green"}>{t("inappLabel")}</Tag>
              ) : (
                <></>
              )}
            </div>
          </div>
        )}
      />
    </PageLayout>
  );
};

export default CrashDetailedView;
